export const independent = "https://www.independenthq.com/";
export const independentLegals = "https://drive.google.com/file/d/1fHBn5BweEY1j5Z_cy_ecvMjys3pzdmLQ/view";
export const independentCookiePolicy = "https://drive.google.com/file/d/1fHBn5BweEY1j5Z_cy_ecvMjys3pzdmLQ/view";
export const independentPrivacyPolicy = "https://drive.google.com/file/d/1fHBn5BweEY1j5Z_cy_ecvMjys3pzdmLQ/view";

export const signUpQueryConfig = {
  theme: "fvr",
};
export const publicSignUpLink = "https://www.independenthq.com/";
